// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__N0TEX","footer":"ModalUpdate_footer__3MuRK"};